module.exports = __webpack_public_path__ + "static/media/spinning-loader.1a242e64.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/spinning-loader.gif
// module id = 46
// module chunks = 0